<template>
  <div ref="parent" style="height: 20px; width: 20px; border: thin solid red;"></div>
</template>

<script>
import Picker from 'vanilla-picker-mini'

export default {
  name: 'color-picker',
  data: () => ({
    picker: null
  }),
  mounted () {
    this.picker = new Picker(this.$refs.parent)

    this.picker.onChange = color => {
      console.log(color)
    }
  },
  destroyed () {

  }
}
</script>
